var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("persistent-toggle", {
    attrs: { "storage-key": _vm.notification.storageKey },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ close }) {
          return [
            _c(
              "base-notificator",
              {
                class: _vm.notification.class,
                attrs: {
                  type: _vm.notification.type,
                  "can-close": _vm.notification.canClose,
                  qa: _vm.notification.qa,
                },
                on: { close: close },
              },
              [
                _vm.notification.action
                  ? [
                      _c(
                        "div",
                        { staticClass: "_flex _jc-sb _ai-c _fd-c _fd-r--m" },
                        [
                          _c("span", { staticClass: "_mt-0" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.notification.message) +
                                "\n                "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "_flex _ai-c _gap-3 _shrink-0" },
                            [
                              _vm.notification.canDismiss
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "_pa-0 _mx-1 _tdu",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return close.apply(null, arguments)
                                        },
                                      },
                                    },
                                    [_vm._v("Dismiss")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "base-button",
                                {
                                  attrs: {
                                    theme: "transparentInverse",
                                    "data-qa": `notificator-button:${_vm.notification.action.label}`,
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.notification.action.onClick.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.notification.action.label) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  : [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.notification.message) +
                          "\n        "
                      ),
                    ],
              ],
              2
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }